import { getProtocolStatusApi } from '@services/protocol';
import { setStepsForNotes } from '@state-mgmt/slices/notesSlice';
import { AppDispatch, RootState } from '@state-mgmt/store';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function useGetSteps({ trialId, protocolId }: { trialId: string | null | undefined; protocolId: string | null | undefined }) {
  const dispatch = useDispatch<AppDispatch>();

  const steps = useSelector((state: RootState) => state.notes.steps);

  useEffect(() => {
    if (trialId && protocolId && !steps[protocolId]) {
      getProtocolStatusApi({ trialId, protocolId }).then(status => {
        dispatch(setStepsForNotes({ protocolId, steps: status?.status || [] }));
      });
    }
  }, [trialId, protocolId]);

  return {
    steps: protocolId ? steps[protocolId] || null : null
  };
}
